// extracted by extract-css-chunks-webpack-plugin
module.exports = {"serviceMenuMobileLinks":"_2gxpdW","itemLink":"_3e-g2s"};